@if (editUserForm) {
	<div class="mb-6 flex items-start lg:items-end">
		<div class="flex flex-1 flex-col gap-4">
			<div class="text-base font-bold text-black">User Role Assignment</div>
		</div>
	</div>
	<form [formGroup]="editUserForm">
		<div class="grid grid-cols-2 gap-4 gap-y-0">
			<div class="form-element">
				<mat-label for="name">Full Name</mat-label>
				<mat-form-field appearance="outline" class="form-field form-field-responsive mt-1 w-full">
					<input type="text" formControlName="name" matInput placeholder="Full Name" class="uppercase" readonly />
					@if (name.errors) {
						<mat-error>
							{{ sharedService.getErrorMessage(name) }}
						</mat-error>
					}
				</mat-form-field>
			</div>

			<div class="form-element">
				<mat-label for="email">Email Address</mat-label>
				<mat-form-field appearance="outline" class="form-field w-ful form-field-responsive mt-1">
					<input type="email" formControlName="email" matInput placeholder="Email Address" readonly />
					@if (email.errors) {
						<mat-error>
							{{ sharedService.getErrorMessage(email) }}
						</mat-error>
					}
				</mat-form-field>
			</div>
		</div>

		<div class="grid grid-cols-2 gap-4 gap-y-0">
			<div class="form-element">
				<mat-label for="form-role">Role</mat-label>
				<mat-form-field appearance="outline" class="role-field form-field form-field-responsive mt-1 w-full">
					<mat-select formControlName="role" placeholder="Select Role" multiple>
						<mat-select-trigger>
							<mat-chip-set>
								@for (selectedRole of role.value; track selectedRole) {
									<mat-chip (removed)="removeRole(selectedRole)" [removable]="true">
										{{ getRoleDisplayName(selectedRole) }}
										<mat-icon matChipRemove>cancel</mat-icon>
									</mat-chip>
								}
							</mat-chip-set>
						</mat-select-trigger>

						@for (roleOption of rolesOptions; track roleOption) {
							<mat-option [value]="roleOption.code">{{ roleOption.code | titlecase }}</mat-option>
						}
					</mat-select>

					@if (role.errors) {
						<mat-error>
							{{ sharedService.getErrorMessage(role) }}
						</mat-error>
					}
				</mat-form-field>
			</div>
		</div>

		<mat-divider></mat-divider>

		<div class="form-actions mt-9 flex flex-row justify-between">
			<div class="cancel-btn">
				<button (click)="goBack()" class="aa-btn" data-variant="tertiary">Cancel</button>
			</div>
			<div class="save-btn">
				<button class="aa-btn" data-variant="primary" (click)="onSubmit()" [disabled]="editUserForm.invalid">
					Assign
				</button>
			</div>
		</div>
	</form>
}
